module.exports = __webpack_public_path__ + "img/motorway_5x1_z16.17f41719.svg";